import React from 'react';
import { Box, IconButton, Tooltip } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CreateIcon from '@material-ui/icons/Create';
import SaveIcon from '@material-ui/icons/Save';

const SectionEditActions = ({
  isEditing,
  onEdit,
  onCancel,
  onSave,
  showActions,
  submitDisabled,
  editButtonId,
  saveButtonId,
  cancelButtonId,
}) => {
  if (!showActions) {
    return null;
  }

  if (!isEditing) {
    return (
      <Tooltip title="Edit">
        <IconButton
          id={editButtonId}
          type="button"
          color="primary"
          onClick={onEdit}
          aria-label="Edit"
        >
          <CreateIcon />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Box display="flex" alignItems="center">
      <Tooltip title="Cancel">
        <IconButton
          id={cancelButtonId}
          type="button"
          onClick={onCancel}
          aria-label="Cancel"
        >
          <CloseIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Save">
        <span>
          <IconButton
            id={saveButtonId}
            type="button"
            color="secondary"
            onClick={onSave}
            disabled={submitDisabled}
            aria-label="Save"
          >
            <SaveIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default SectionEditActions;
